<template>
  <el-dialog :title="pushType === 2 ? '紧急通知' : '消息详情'"
             :visible.sync="visible"
             @close="close"
             class="message-dialog"
  >
    <div v-loading="loading">
      <div class="m-head">
        <p class="title" v-html="message.title"></p>
        <p class="sub-title">{{message.publish_time}}</p>
      </div>
      <div class="m-body" v-html="message.content"></div>
      <div class="m-footer" v-if="!pushType">
        <span v-if="message.lastId || message.nextId">阅读：</span>
        <span><a href="javascript:void(0)" v-show="message.lastId" @click="updateId(message.lastId)">下一篇消息</a></span>
        <span class="spacer" v-show="message.nextId && message.lastId">|</span>
        <span><a href="javascript:void(0)" v-show="message.nextId" @click="updateId(message.nextId)">上一篇消息</a></span>
      </div>
    </div>
    <div slot="footer">
      <el-button type="primary" @click="visible = false">知道了</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import getUnreadMessageInfo from '@util/getUnreadMessageInfo';

  export default {
    data () {
      return {
        visible: false,
        message: {},
        id: null,
        isRead: false,
        pushType: 0,
        loading: true
      };
    },
    methods: {
      init () {
        let _this = this,
            data = {
              id: _this.id,
              platform: 'HQ',
              isRead: _this.isRead
            };
        _this.loading = true;
        _this.$axios.post('/irs-api/ces-web/user/api/v3/message/detail', _this.$qs.stringify(data)).then((res) => {
          _this.loading = false;
          _this.message = res.data;
          if (_this.message.is_read === 0) {
            getUnreadMessageInfo(true);
          }
        });
      },
      updateId (newId) {
        this.id = newId;
        this.init();
      },
      show (id, isRead, pushType) {
        this.id = id;
        this.isRead = isRead;
        this.pushType = +pushType;
        this.init();
        this.visible = true;
        this.message = {};
      },
      close () {
        this.$emit('close');
        getUnreadMessageInfo(true);
      }
    }
  };
</script>

<style lang="less">
  .message-dialog {
    line-height: 40px;

    .m-head {
      background: #f8f8f8;
      height: 50px;
      padding: 15px 20px;

      .title {
        font-size: 18px;
        color: #333333;
        line-height: 30px;
        font-weight: bold;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .sub-title {
        font-size:12px;
        color:#9b9b9b;
        line-height: 20px;
      }
    }

    .m-body {
      margin: 20px 0 30px;
      max-height: 400px;
      overflow-x: hidden;
      overflow-y: auto;
      line-height: normal;
    }
    .m-footer {
      .spacer {
        margin: 0 10px;
      }
      a {
        color: #016cdf;
        text-decoration: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// MessageDialog.vue?699e4cb8